(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pawce-glow-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pawce-review-notes')) {
  customElements.define('pawce-review-notes', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.filter = 'all';
      this.page = 1;
      this.pageSize = 5;
      this.querySelector('[data-review-sort]').value = 'original';
      this.querySelector('.pawce-reviews__tools').hidden = false;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-review-filter]');
        if (filter) {
          this.filter = filter.dataset.reviewFilter;
          this.page = 1;
          this.update();
          return;
        }
        const page = event.target.closest('[data-review-page]');
        if (page && !page.disabled) {
          this.page = Number(page.dataset.reviewPage);
          this.update();
          this.querySelector('[data-review-pagination] [aria-current="page"]')?.focus({preventScroll:true});
          this.querySelector('.pawce-reviews__tools').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        }
      }, {signal:this.controller.signal});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-review-sort]')) {
          this.page = 1;
          this.update();
        }
      }, {signal:this.controller.signal});
      this.addEventListener('shopify:block:select', event => {
        this.filter = 'all';
        this.querySelector('[data-review-sort]').value = 'original';
        const card = event.target.closest('[data-review-card]');
        this.page = card ? Math.floor(this.cards.indexOf(card)/this.pageSize)+1 : 1;
        this.update();
      }, {signal:this.controller.signal});
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const sort = this.querySelector('[data-review-sort]').value;
      const grid = this.querySelector('[data-review-grid]');
      const sorted = [...this.cards].sort((a,b) => {
        const position = Number(a.dataset.position)-Number(b.dataset.position);
        if (sort === 'original') return position;
        if (sort === 'high' || sort === 'low') {
          const ar = Number(a.dataset.rating), br = Number(b.dataset.rating);
          if (!ar || !br) return ar ? -1 : br ? 1 : position;
          return (sort === 'high' ? br-ar : ar-br) || position;
        }
        return b.dataset.date.localeCompare(a.dataset.date) || position;
      });
      const filtered = sorted.filter(card => this.filter === 'all' || card.dataset.topic === this.filter);
      const pages = Math.max(1,Math.ceil(filtered.length/this.pageSize));
      this.page = Math.min(Math.max(1,this.page),pages);
      const start = (this.page-1)*this.pageSize;
      const visible = new Set(filtered.slice(start,start+this.pageSize));
      sorted.forEach(card => {card.hidden=!visible.has(card);grid.append(card);});
      this.querySelectorAll('[data-review-filter]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.reviewFilter===this.filter)));
      const status = this.querySelector('[data-review-status]');
      status.textContent = status.dataset.label.replace('[start]',filtered.length?start+1:0).replace('[end]',Math.min(start+this.pageSize,filtered.length)).replace('[total]',filtered.length);
      this.querySelector('[data-review-empty]').hidden = filtered.length !== 0;
      const nav = this.querySelector('[data-review-pagination]');
      nav.replaceChildren();
      nav.hidden = pages <= 1;
      const makeButton = (label,page,disabled,ariaLabel) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.dataset.reviewPage = String(page);
        button.disabled = disabled;
        if (ariaLabel) button.setAttribute('aria-label',ariaLabel);
        nav.append(button);
        return button;
      };
      makeButton('←',this.page-1,this.page===1,nav.dataset.previous);
      for(let page=1;page<=pages;page++) {
        const button = makeButton(String(page),page,false,nav.dataset.pageLabel.replace('[number]',page));
        if(page===this.page) button.setAttribute('aria-current','page');
      }
      makeButton('→',this.page+1,this.page===pages,nav.dataset.next);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
